<span
  *ngIf="status | statusChip as chipDisplay"
  class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full text-center"
  [ngClass]="chipDisplay.backgroundAndText"
>
  {{ status | titleCaseAndClean }}
</span>
